/** @jsxImportSource @emotion/react */

import { IconButton } from '@nike/nike-design-system-components';
import { Sort } from '@nike/nike-design-system-icons';
import { nike } from '@nike/nike-design-tokens';
import { useState, useEffect, useRef } from 'react';

import UsersInvitationsSortButtons from './UsersInvitationsSortButtons';

import { TranslatedCopy } from '../intl/TranslatedCopy';

const UsersInvitationsSort = () => {
  const [isOpen, setIsOpen] = useState(false);

  const sortButtonRef = useRef(null);
  const sortDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        isOpen &&
        !sortDropdownRef.current?.contains(event.target) &&
        !sortButtonRef.current?.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [sortDropdownRef, isOpen]);

  return (
    <div
      css={{
        position: 'relative'
      }}
    >
      <IconButton
        appearance='secondary'
        ariaLabel={new TranslatedCopy({ id: 'global.sortBy' }).toString()}
        onClick={() => setIsOpen(!isOpen)}
        size='small'
        Icon={<Sort />}
        ref={sortButtonRef}
      />

      {isOpen && (
        <div
          css={{
            background: nike.podiumCdsColorBgAlwaysLight,
            border: `1px solid ${nike.podiumCdsColorBorderPrimary}`,
            borderRadius: '5px',
            marginTop: '12px',
            position: 'absolute',
            right: 0,
            transition: 'opacity 0.2s linear',
            whiteSpace: 'nowrap',
            zIndex: 2
          }}
          ref={sortDropdownRef}
        >
          <UsersInvitationsSortButtons />
        </div>
      )}
    </div>
  );
};

export default UsersInvitationsSort;
